import React from "react";

// A single tick-off item. The whole row is the label so it is comfortable to tap
// on a phone, which is where photographers use this.
const DispatchCheck = (props) => {
    const { itemKey, label, hint, checked, onToggle } = props;

    // Checked styling is driven by a class rather than CSS :has(), which older
    // mobile Safari does not support — and phones are the primary target here.
    return (
        <label className={checked ? "check is-checked" : "check"}>
            <input
                type="checkbox"
                className="cb"
                checked={checked}
                onChange={() => onToggle(itemKey)}
            />
            <div className="box" aria-hidden="true">✓</div>
            <div className="txt">
                {label}
                {hint && <small>{hint}</small>}
            </div>
        </label>
    );
};

export default DispatchCheck;
